import { Store } from "../../types/model";
import { Page } from "../../types/Seo";
import { EVENT_LIST } from "./enums";

export default function getEventListSeo(selectedStore: Store, page: Page, t: Function) {
  const title = selectedStore
    ? t("event.storePageTitle", { storeName: selectedStore?.storeName })
    : t("event.pageTitle");

  const description = selectedStore
    ? "storeEventCustomer.storeDescription"
    : "storeEventCustomer.listDescription";

  const meta = [{
    name: "description",
    content: t(description, { storeName: selectedStore?.storeName }),
  }];

  const robots = (page === EVENT_LIST && !selectedStore) ? [{
    name: 'robots',
    content: 'noindex'
  }] : [{
    name: 'robots',
    content: 'index, follow'
  }];

  return {
    jsonLd: null,
    meta: [...meta, ...robots],
    title,
    canonicalPath: null,
  };
}
